<template>
  <div :class="{'hidden-banner': isHidden, 'not-hidden-banner': !isHidden}">
    <div class="remote-control banner1 mt-5" style="padding-top: 20px;">
      <button @click="goLink('product', '', 'F-2681372XZC', 'F')">  
        <img src="../assets/img/remote/rt_puk_shin2.png" alt="">
      </button>
      <!-- <button @click="goLink('page', 'themeStore_Ski', '', '')"> -->
      <!-- <button @click="goLink('page2', 'customerNotice', 'EV-1768273628445', '')">  
        <img src="../assets/img/remote/rt_pukwan02.png" alt="">
      </button> -->
    </div>
    <div class="remote-control banner1 mt-2">
      <button @click="goLink('product', '', 'L-20231220-1703058504372', 'L')">  
        <img src="../assets/img/remote/rt_asahiyama_zoo.jpg" alt="">
      </button>
      <!-- <button @click="goLink('page', 'themeStore_Ski', '', '')"> -->
      <!-- <button @click="goLink('page2', 'customerNotice', 'EV-1768273628445', '')">  
        <img src="../assets/img/remote/rt_pukwan02.png" alt="">
      </button> -->
    </div>
    <div class="remote-control banner3 mt-2">
      <button @click="goLink('page', 'nbus_mainpage', '', '')">
        <img src="../assets/img/remote/nbremote2.jpg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isHidden: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.updateBannerPosition();
    window.addEventListener('resize', this.updateBannerPosition);
    window.addEventListener('scroll', this.handleScroll);         // 스크롤 이벤트 추가

    // 배성운대리 제안(스크롤과정에서 배너 등장 and 퇴장으로 처리하는 로직)
    // document.addEventListener('DOMContentLoaded', function() {
    //   window.addEventListener('scroll', function() {
    //     //winHeight = 699;
    //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //     //console.log("scrollTop:", scrollTop)

    //     if (element) 
    //     {
    //       if (scrollTop < 700) {
    //         element.style.display = 'none';
    //       } 
    //       else
    //       {
    //         element.style.display = 'block';
    //       }
    //     }
    //   });
    // });
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateBannerPosition);
    window.removeEventListener('scroll', this.handleScroll); 
  },

  methods: {
    updateBannerPosition() {
      const topBanner = document.querySelector('.topBanner');
      if (topBanner) {
        document.documentElement.style.setProperty('--top-banner-height', `${topBanner.offsetHeight}px`);
      }
    },

    handleScroll() {
      const banner = document.querySelector('.not-hidden-banner');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (banner) {
        if (scrollTop > 300) {
          banner.style.top = '300px';                 // 스크롤이 300px 이상일 때 고정
        } else {
          banner.style.top = `${785 - scrollTop}px`;  // 스크롤이 적을 때 동적으로 조정
        }
      }
    },


    goLink(type, link, pId, sR) {
      if(type === "page") 
      {
        this.$router.push({path: `/${link}`});
      } 
      else if(type === "product") {
        this.$router.push({path: '/detail', query: {productId: pId, salesRoute: sR}});
      }
      else if(type === "page2") 
      {
        this.$router.push({path: `/${link}`, query: {nCode: pId}});
      }
    },
  }
};
</script>

<style scoped>
.remote-control button {
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 310px;
  height: 105px;
  overflow: hidden;
  padding: 0;
  transition: all 0.5s;
}

button img {
  width: 100%;
  transition: all 0.5s;
}

.banner1 button { background-color: #161302; }
.banner2 button { background-color: #000; }
.banner3 button { background-color: #000; }

.remote-control button:hover {
  transform: translate(-10px);
} 

.hidden-banner {
  display: none;
}

.not-hidden-banner {
  position: fixed;
  left: calc(var(--left-width) + 100px) !important;
  top: 785px;                 /* 초기 위치 */
  transition: top 0.3s ease;  /* 부드러운 이동 효과 */
  z-index: 1000;
}
.hidden-banner {
  display: none;
}
</style>
